import { Box } from '@mantine/core';
import { useGetColor } from '../hooks';
import type { IconPropsType } from './types';

export const ScissorIcon = ({
  size = 24,
  sx,
  color,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.6667 7.44444L3 17.2222M13.6669 14.5556L10.1111 11M3 4.77788L7.88889 9.22222M19 5.66667C19 7.13942 17.8061 8.33333 16.3333 8.33333C14.8605 8.33333 13.6667 7.13942 13.6667 5.66667C13.6667 4.19391 14.8605 3 16.3333 3C17.8061 3 19 4.19391 19 5.66667ZM19 16.3333C19 17.8061 17.8061 19 16.3333 19C14.8605 19 13.6667 17.8061 13.6667 16.3333C13.6667 14.8605 14.8605 13.6667 16.3333 13.6667C17.8061 13.6667 19 14.8605 19 16.3333Z"
        stroke={iconColor}
        strokeWidth="1.5"
      />
    </Box>
  );
};
